<script lang="ts">
    import Link from "svelte-link";
    import { Button, Col, Image, Row } from "sveltestrap";
    import { ENDCALL, href } from "../../../../utils/Constant/Constant";
    import data from "../../../../Data/Chat/Chat.json"
    let imgPath:String = "/assets/images/other-images"
</script>
<div class="chat-history">
    <Row>
      <Col class="text-center pe-0 call-content">
        <div>
          <div class="total-time">
            <h2>36 : 56</h2>
          </div>
          <div class="call-icons">
            <ul class="list-inline">
                {#each data.callicondata as chatItem}
                    <li class="list-inline-item">
                        <Link href={href}>
                            <i class={chatItem.icon}></i>
                        </Link>
                    </li>
                {/each}
            </ul>
          </div>
          <Button class="btn-danger-gradien btn-block btn-lg">{ENDCALL}</Button>
          <div class="receiver-img">
            <Image src="{imgPath}/receiver-img.jpg" alt="" />
          </div>
        </div>
      </Col>
      <Col sm="6" class="caller-img-sec">
        <Image fluid src="{imgPath}/caller.jpg" alt="" />
      </Col>
    </Row>
</div>